// Очередь отправки записей: правка не теряется, если сеть/сервер мигнули.
// Операции идемпотентны (upsert/delete), поэтому повторная отправка безопасна.
// Состояние хранится в localStorage, переживает закрытие вкладки.
const LS_KEY = 'fh_outbox_v1';
const ops = {};
const listeners = new Set();
let items = [];
let flushing = false;
let timer = null;
let attempt = 0;
let lastError = '';
let labelOf = () => '';
export function setLabelResolver(f) { labelOf = f; }

function load() {
  try { items = JSON.parse(localStorage.getItem(LS_KEY) || '[]'); } catch (e) { items = []; }
  if (!Array.isArray(items)) items = [];
}
function persist() {
  try { localStorage.setItem(LS_KEY, JSON.stringify(items)); } catch (e) { /* ignore */ }
}
function emit() {
  const s = getState();
  listeners.forEach(f => { try { f(s); } catch (e) { /* ignore */ } });
}

export function getState() {
  return { pending: items.length, flushing, lastError, labels: items.slice(0, 8).map(i => i.label || i.key) };
}
export function subscribe(f) { listeners.add(f); f(getState()); return () => listeners.delete(f); }
export function registerOp(name, fn) { ops[name] = fn; }

function safeLabel(op, payload) { try { return labelOf(op, payload) || ''; } catch (e) { return ''; } }

function schedule() {
  if (timer) clearTimeout(timer);
  if (!items.length) return;
  const delays = [5000, 15000, 30000, 60000];
  const d = delays[Math.min(attempt, delays.length - 1)];
  timer = setTimeout(flush, d);
}

export async function flush() {
  if (flushing || !items.length) return;
  flushing = true; emit();
  try {
    while (items.length) {
      const it = items[0];
      const fn = ops[it.op];
      if (!fn) { items.shift(); persist(); continue; }  // неизвестная операция — выбрасываем
      await fn(it.payload);
      items.shift(); persist(); lastError = ''; attempt = 0;
      emit();
    }
  } catch (e) {
    lastError = (e && (e.message || e.code)) || 'ошибка сети';
    attempt++;
  } finally {
    flushing = false; emit(); schedule();
  }
}

// Отправить сразу. Если не вышло — оставить в очереди и повторять сами.
// key: одна запись на ключ (последняя правка заменяет предыдущую неотправленную).
export async function submit(op, payload, key) {
  const fn = ops[op];
  // порядок важен: сначала уходит накопленное, потом новое
  if (items.length) {
    items = items.filter(i => i.key !== key);
    items.push({ op, payload, key, label: safeLabel(op, payload), ts: Date.now() });
    persist(); emit();
    await flush();
    return { queued: items.some(i => i.key === key) };
  }
  try {
    await fn(payload);
    return { queued: false };
  } catch (e) {
    items = items.filter(i => i.key !== key);
    items.push({ op, payload, key, label: safeLabel(op, payload), ts: Date.now() });
    persist(); lastError = (e && (e.message || e.code)) || 'ошибка сети'; attempt = 0;
    emit(); schedule();
    return { queued: true };
  }
}

export function initOutbox() {
  load();
  if (typeof window === 'undefined') return;
  window.addEventListener('online', () => { attempt = 0; flush(); });
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') flush(); });
  window.addEventListener('beforeunload', (e) => {
    if (items.length) { e.preventDefault(); e.returnValue = 'Есть несохранённые изменения'; return e.returnValue; }
    return undefined;
  });
  emit();
  if (items.length) setTimeout(flush, 1500);
}
